/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `dangerous` - Mărfuri periculoase
 * * `high_value` - Mărfuri de mare valoare
 * * `refrigerated` - Mărfuri frigorifice / perisabile
 * * `alcoholic` - Băuturi alcoolice
 * * `tobacco` - Produse din tutun
 * * `electronics` - Produse electronice
 * * `vehicles` - Vehicule / piese de schimb pentru vehicule
 * * `fragile` - Mărfuri fragile
 * * `special_conditions` - Mărfuri care necesită condiții speciale de transport
 */
export enum CMRSpecialCargoTypeTypeEnum {
  DANGEROUS = 'dangerous',
  HIGH_VALUE = 'high_value',
  REFRIGERATED = 'refrigerated',
  ALCOHOLIC = 'alcoholic',
  TOBACCO = 'tobacco',
  ELECTRONICS = 'electronics',
  VEHICLES = 'vehicles',
  FRAGILE = 'fragile',
  SPECIAL_CONDITIONS = 'special_conditions',
}
